export default "__VITE_ASSET__ad3b145e__"